var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',[_c('dt',[_c('strong',[_vm._v(_vm._s(_vm.name))]),_vm._v(": "+_vm._s(_vm.description))]),_c('dd',[_c('ol',_vm._l((_vm.definitions),function(d){return _c('li',{key:d,domProps:{"textContent":_vm._s(d)}})}),0)])])}
var staticRenderFns = []

export { render, staticRenderFns }